import React from 'react';
import PropTypes from 'prop-types';
import { abbreviateNumber } from 'app/utils/numbers';
import { userProps } from 'app/utils/propValidation';
import { Image, Row, NumericalValue, Text } from 'modules/styled';

const iconImage = require('public/img/r-emoji.png');

export default function RStat(props) {
  const {
    size = 3,
    user,
    color,
    mr,
    align,
    lh,
    inline,
    noSpace,
    spaceBetween,
    ...rest
  } = props;
  if (!user) {
    return null;
  }
  const pagerank = Math.max(0, user?.relevance?.reputation || 0);
  const imageMargin = align === 'center' ? -1 : 0.5;

  let spacer = spaceBetween || size;

  if (inline) {
    return (
      <Text {...rest} inline={inline ? 1 : 0} align={align || 'center'}>
        <Image
          source={iconImage}
          sx={{
            height: size,
            width: size,
            transform: [{ translateY: imageMargin }],
          }}
          resizeMode="contain"
        />
        {noSpace ? '' : ' '}
        <Row sx={{ width: spacer + 0.000001, height: 0 }} />
        <NumericalValue
          inline={inline ? 1 : 0}
          sx={{ color: color || 'black', lineHeight: 8 * lh || 2 }}
        >
          {abbreviateNumber(Number(pagerank.toFixed(2))) || 0}
        </NumericalValue>
      </Text>
    );
  }

  return (
    <Row
      {...rest}
      sx={{ alignItems: align, mr: mr === 'number' ? mr : inline ? 0 : 1.5001 * 8 }}
    >
      <Image
        source={iconImage}
        sx={{
          height: size,
          width: size,
          transform: [{ translateY: imageMargin }],
        }}
        resizeMode="contain"
      />
      <Row sx={{ width: spacer + 0.000001, height: 0 }} />
      <NumericalValue sx={{ color: color || 'black', lineHeight: 8 * lh || 2 }}>
        {abbreviateNumber(Number(pagerank.toFixed(2))) || 0}
      </NumericalValue>
    </Row>
  );
}

RStat.propTypes = {
  inline: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  lh: PropTypes.number,
  align: PropTypes.string,
  mr: PropTypes.number,
  color: PropTypes.string,
  user: userProps,
  size: PropTypes.number,
  spaceBetween: PropTypes.number,
  noSpace: PropTypes.bool,
};
